import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWestfieldSuiteinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11 46.188c-2.31-.688-4-2.882-4-5.482C7 37.555 9.482 35 12.543 35c3.062 0 5.544 2.555 5.544 5.706 0 .445-.05.878-.143 1.294h29.435a5.83 5.83 0 0 1-.466-2.294c0-3.151 2.482-5.706 5.544-5.706C55.518 34 58 36.555 58 39.706c0 2.275-1.293 4.24-3.164 5.156A4 4 0 0 1 55 46v3a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4v-2.812zM55 30v4.088M11 30v5m0-6c0-.162.005-.322.014-.48C11.167 25.984 12.57 24 16 24h34c3.645 0 5 2.239 5 5",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M16 36h32" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M22 53v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4h9zm31 0v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4h9zM41.25 5h7.5L50 12H40zM45 12v12",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgWestfieldSuiteinline;
